// src/quiz/gre-mock5/index.js
// GRE Mock 5 — props for the shared Gre_verbal / Gre_quantitative /
// Gre_analytical components. Test names end in "Mock 5" so the profile
// keeps these results apart from the other mocks.
import verbalQuestions from "./verbalData";
import { section1Questions, section2Questions } from "./quantitativeData";

export const greMock5 = {
  verbal: {
    questions: verbalQuestions,
    testName: "GRE Verbal Reasoning Mock 5",
    title: "GRE Verbal Reasoning — Mock 5",
  },
  quantitative: {
    section1: section1Questions,
    section2: section2Questions,
    testName: "GRE Quantitative Reasoning Mock 5",
    title: "GRE Quantitative Reasoning — Mock 5",
  },
  analytical: {
    testName: "GRE Analytical Writing Mock 5",
    title: "GRE Analytical — Mock 5",
    prompt:
      "\"Governments should fund basic scientific research even when it has no foreseeable practical application.\"",
    directions:
      "Write a response in which you discuss your views on the policy and explain your reasoning for the position you take. In developing and supporting your position, you should consider the possible consequences of implementing the policy and explain how these consequences shape your position.",
    topicKeywords: [
      "govern", "fund", "research", "scien", "basic", "practical",
      "applica", "discover", "public", "innovat", "taxpay", "consequen",
    ],
  },
};
